export const regionFeatures = {
  MYS: {
    enable_bulk_upload: { defaultValue: false, label: 'WebApp E-invoice Bulk Upload' },
    enable_sftp: { defaultValue: false, label: 'SFTP Bulk Upload' },
    enable_consolidation: { defaultValue: false, label: 'Consolidation of E-invoice' },
    enable_peppol: { defaultValue: false, label: 'Peppol Document Transmission' },
    enable_pdf_data_extraction: { defaultValue: false, label: 'PDF Data Extraction' },
    api_integration_enabled: { defaultValue: false, label: 'Enable API Integration' },
    enable_shopify_integration: { defaultValue: false, label: 'Shopify integration' },
  },
  KSA: {
    document_approval_workflow: { defaultValue: false, label: 'Document approval workflow' },
    enable_3rd_party_pos_invoicing: { defaultValue: false, label: 'Third-party POS invoicing' },
    zatca_phase2: { defaultValue: false, label: 'ZATCA Phase 2 compliance' },
    enable_online_pos: { defaultValue: false, label: 'Online POS' },
    enable_xero_integration: { defaultValue: false, label: 'Xero integration' },
    enable_shopify_integration: { defaultValue: false, label: 'Shopify integration' },
    enable_chargebee_integration: { defaultValue: false, label: 'Chargebee integration' },
    enable_quickbooks_integration: { defaultValue: false, label: 'QuickBooks integration' },
    enable_woocommerce_integration: { defaultValue: false, label: 'WooCommerce integration' },
    enable_api_integration: { defaultValue: false, label: 'API integration' },
    allow_sftp_integration: { defaultValue: false, label: 'SFTP integration' },
    allow_bulk_doc_creation: { defaultValue: false, label: 'Bulk document creation' },
    allow_nontax_document_creation: { defaultValue: false, label: 'Non-tax document creation' },
    enable_vat_reconciliation: { defaultValue: false, label: 'VAT reconciliation' },
    enable_bulk_download_pdf_documents: { defaultValue: false, label: 'Bulk download of PDF documents' },
    enable_claims: { defaultValue: false, label: 'Claims' },
    enabled_payment_info_on_b2c_invoice: { defaultValue: false, label: 'Payment info_on b2c invoice' },
    enable_track_customer_expenses: { defaultValue: false, label: 'Track customer expenses' },
    enable_track_invoice_payments: { defaultValue: false, label: 'Track invoice payment' },
    enable_pdf_custom_data: { defaultValue: false, label: 'PDF custom data' },
    enable_elastic_search: { defaultValue: false, label: 'Elastic search for query' },
    enable_document_reconciliation: { defaultValue: false, label: 'Document reconciliation' },
    send_integration_failure_notifications: { defaultValue: false, label: 'Send integration failure notifications' },
    enable_marmin_assist: { defaultValue: false, label: 'Marmin Assistant' },
  },
  UAE: {
    enable_bulk_upload: { defaultValue: false, label: 'WebApp E-invoice Bulk Upload' },
    enable_phase2: { defaultValue: false, label: 'Phase 2 compliance' },
    enable_api_integration: { defaultValue: false, label: 'API integration' },
    enable_vat_report: { defaultValue: false, label: 'VAT report' },
    enable_register: { defaultValue: false, label: 'Document register' },
  },
};
